import webPreviewConsoleTemplate from './web-preview-console.tpl.html';
import './web-preview-console.less';
import { scrollMonitorServiceModule } from '../../services/scroll-monitor-service/scroll-monitor-service';

export const webPreviewConsoleComponentModule = angular
  .module('Q.components.web-preview-console', [scrollMonitorServiceModule])

  .component('webPreviewConsole', {
    bindings: {
      console: '<',
    },
    controller: 'WebPreviewConsoleCtrl',
    template: webPreviewConsoleTemplate,
  })
  .controller(
    'WebPreviewConsoleCtrl',
    function WebPreviewConsoleCtrl($scope, $element, scrollMonitorService) {
      const ctrl = this;
      const $history = $element.querySelector('.web-preview-console-history');

      ctrl.clear = () => {
        ctrl.console.length = 0;
      };

      ctrl.autoScroll = true;
      ctrl.toggleAutoScroll = () => {
        ctrl.autoScroll = !ctrl.autoScroll;
        if (ctrl.autoScroll) {
          $history.scrollTop(
            $history[0].scrollHeight - $history[0].offsetHeight,
          );
        }
      };

      ctrl.expand = (d) => {
        if (d.expandable) {
          ctrl.autoScroll = false;
          d.expanded = !d.expanded;
        }
      };

      ctrl.$onInit = () => {
        if (ctrl.console.lineWrap === undefined) {
          ctrl.console.lineWrap = true;
        }
        const scrollWatcher = scrollMonitorService.addListener(
          $history,
          (event, data) => {
            if (event.type === 'scroll' || event.type === 'touchmove') {
              // if we're at the bottom, auto scroll
              ctrl.autoScroll =
                data.viewportScrollHeight <=
                data.viewportScrollTop + data.viewportHeight;
              // update UI if necessary
              $scope.$applyAsync();
            } else if (ctrl.autoScroll) {
              // scroll to bottom if anything changed
              $history.scrollTop(
                data.viewportScrollHeight - data.viewportHeight,
              );
            }
          },
        );
        $scope.$on('$destroy', () => {
          scrollWatcher.destroy();
        });
      };
    },
  );
